import { useState } from "react";
import { Button, Tooltip } from "antd";

import { Task } from "../../types/task";

import UpdateTaskModal from "../Modals/UpdateTask/UpdateTask";
import { RedoOutlined } from "@ant-design/icons";

const ReuploadButton = ({ task }: { task: Task }) => {
  const [openModal, setOpenModal] = useState(false);

  const onOpenModal = () => setOpenModal(true);
  const onCloseModal = () => setOpenModal(false);

  return (
    <>
      <Tooltip title="Recarregar tasca">
        <Button onClick={onOpenModal} icon={<RedoOutlined />} />
      </Tooltip>
      {openModal && (
        <UpdateTaskModal
          isOpen={openModal}
          taskId={task.id}
          onCancel={onCloseModal}
        />
      )}
    </>
  );
};
export default ReuploadButton;
